module.exports = __webpack_public_path__ + "img/eyein-partner-telus.31e52226.png";